export default "__VITE_ASSET__BLapRR_K__"